// import { useState } from 'react';
import './App.css';
import About from './components/About/About';
import Home from './components/Home/Home';
import AdminLogin from './components/Pages/AdminLogin';
import AdminUpload from './components/Pages/AdminUpload';
import ProtectedRoute from './components/Pages/ProtectedRoute';
import ProductPage from './components/Pages/ProductPage';
import Shop from './components/Shop/Shop'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminDashboard from './components/Admin/AdminDashboard';
import EditProducts from "./components/Admin/EditProducts";
import ManageCategories from "./components/Admin/ManageCategories";
import Blog from './components/Pages/Blog';
import BlogPost from './components/Pages/BlogPost';
import NotFound from './components/Pages/NotFound';
import ShopHome from './components/Shop/ShopHome';
import RunUpdate from './components/Admin/RunUpdate';
import Contact from './components/Contact/Contact';
import Terms from './components/LegalPages/Terms';
import Refunds from './components/LegalPages/Refunds';
import Shipping from './components/LegalPages/Shipping';
import Privacy from './components/LegalPages/Privacy';
import CookieNotice from './components/LegalPages/CookieNotice';

const siteType = process.env.REACT_APP_SITE_TYPE;

function App() {
  // const [ atHome, setAtHome ] = useState(true);
  
  return (
    <BrowserRouter>
      <div className="App">
          {siteType === "SHOP" ? (
            <Routes>
              <Route path="/" element={<ShopHome />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/shop/:category/:productId" element={<ProductPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refunds" element={<Refunds />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop/about" element={<About />} />
              <Route path="/cookies" element={<CookieNotice />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/update"
                element={
                  <ProtectedRoute>
                    <RunUpdate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/upload"
                element={
                  <ProtectedRoute>
                    <AdminUpload />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/edit"
                element={
                  <ProtectedRoute>
                    <EditProducts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/categories"
                element={
                  <ProtectedRoute>
                    <ManageCategories />
                  </ProtectedRoute>
                }
              />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<ShopHome />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/shop" element={<Shop />} />  
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/shop/:category/:productId" element={<ProductPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refunds" element={<Refunds />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop/about" element={<About />} />
              <Route path="/cookies" element={<CookieNotice />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          )}
      </div>
    </BrowserRouter>
  );
}

export default App;
